import { render } from "./GlTransaction.vue?vue&type=template&id=f5974c52&scoped=true"
import script from "./GlTransaction.vue?vue&type=script&lang=js"
export * from "./GlTransaction.vue?vue&type=script&lang=js"

import "./GlTransaction.vue?vue&type=style&index=0&id=f5974c52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f5974c52"

export default script